import mainStyle from "../../mainStyle.module.scss";
import React, { useState, useEffect, useRef } from 'react';
import { cloneDeep } from "lodash";
import { useTheme } from "@mui/material/styles";
import { Typography, TextField } from "@mui/material";
import { QRCode, Space, message } from 'antd';
import { ReactComponent as CopyIcon } from "assets/images/icons/btn_copy.svg";

const MfaPhase2 = (props) => {
  const {
    setInputOpt, mfaSetting
  } = props;
  const theme = useTheme();

  const [qrText, setQRText] = useState('https://ant.design/');
  const [secretCode, setSecretCode] = useState('');
  const inputsRef = useRef([]);
  const [otp, setOtp] = useState(['', '', '', '', '', '']);

  const handleChange = (e, index) => {
    let tmpVal = e.target.value;

    if (!/^\d*$/.test(e.target.value)) {
      return;
    }

    let tmpOTP = cloneDeep(otp)
    if(tmpVal!=='' && tmpOTP[index]!==''){ //空值才能輸入
      if(index < otp.length-2 && tmpOTP[index+1]===''){
        let letter = tmpVal[tmpVal.length - 1];
        tmpOTP[index+1] = letter;
        setOtp(tmpOTP)
        setInputOpt(tmpOTP)
        inputsRef.current[index + 2]?.focus();
      }else{
        if(tmpVal.length === 1){
          tmpOTP[index] = tmpVal;
          setOtp(tmpOTP)
          setInputOpt(tmpOTP)
          inputsRef.current[index + 1]?.focus();
        }else{
          // console.log('back')
          return;
        }
      }
    }else{
      tmpOTP[index] = tmpVal;
      setOtp(tmpOTP)
      setInputOpt(tmpOTP)
      if(tmpVal!==''){ // 輸入往後推一格
        inputsRef.current[index + 1]?.focus();
      }else{ // 回車往前推ㄧ格
        inputsRef.current[index - 1]?.focus();
      }
    }
    
  }
  const handleKeyDown = (e, index) => {
    // console.log('handleKeyDown')
    // console.log(e.target.value)
    // console.log(e.key)
    // console.log(index)
    if(e.key === 'Enter'){
      if(index < otp.length-1) { // 輸入往後推一格
        inputsRef.current[index + 1]?.focus();
      }
    // }
    // else if(e.key === 'ArrowLeft'){
    //   if(index > 0){ // 回車往前推ㄧ格
    //     inputsRef.current[index - 1]?.focus();
    //   }
    }else if(e.key === 'Backspace' && e.target.value === ''){
      if(index > 0){ // 回車往前推ㄧ格
        inputsRef.current[index - 1]?.focus();
      }
    }
  }

  const handleCopyCode = async () => {
    try {
      await navigator.clipboard.writeText(secretCode);
      message.success('已複製到剪貼簿！');
    } catch (err) {
      message.error('複製失敗');
      // console.error('Copy failed', err);
    }
  }
  

  useEffect(() => {
    if(mfaSetting){
      setQRText(mfaSetting.url)
      setSecretCode(mfaSetting.secret)
    }
  }, [mfaSetting]);

  return (
    <>
      <div className={mainStyle['modal_rows']} >
        <div className={mainStyle['modal_Block']}>
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[4],
              fontWeight: theme.typography.customFontWeight[3],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            Scan the QR code with your Authenticator app or Copy the secret to your Authenticator app
          </Typography>
        </div>
      </div>
      <div className={mainStyle['modal_rows']} >
        <div style={{marginTop: '15px', display:'flex', justifyContent:'center'}}>
          <Space direction="vertical" align="center" >
            <QRCode value={qrText || '-'} size={125}/>
          </Space>
        </div>
        <div style={{marginTop: '15px', display:'flex', justifyContent:'center', gap:'20px'}}>
          <TextField
            value={secretCode}
            onChange={(e) => setQRText(e.target.value)}
            placeholder="-"
            maxLength={60}
            fullWidth
            size="small"
            variant="outlined"
            sx={{
              mr: 1,
              '& .MuiOutlinedInput-root': {
                borderRadius: '10px', // 改變圓角
                '& fieldset': {
                  borderColor: theme.palette.primary.greyThread, // 預設狀態的框線顏色
                },
                "&:hover fieldset": {
                  borderColor: theme.palette.primary.mainHover,
                },
                "&.Mui-focused fieldset": {
                  border: '1px solid',
                  borderColor: theme.palette.primary.main,
                },
              },
            }}
            inputProps={{style: {fontSize: '13px', textAlign: 'center'}}}
            style={{margin:'5px 0px'}}
          />
          <CopyIcon
            style={{ cursor: 'pointer' }}
            width={45}
            onClick={handleCopyCode}
          />
        </div>
        <div style={{marginTop: '15px'}}>
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[4],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            Enter verify code
          </Typography>
        </div>
        <div className={mainStyle["modal_verifyCode"]}
          style={{marginTop: '15px', display:'flex', justifyContent:'center', alignItems:'center'}}>
          <div style={{marginRight: '30px',  display:'flex', gap:'10px'}}>
            {otp.map((value, index) => (
              <input
              className={`
                ${value===''||value===null? mainStyle['modal_verifyCode_empty']:mainStyle['modal_verifyCode_pass']}`}
                key={index}
                value={value}
                onChange={(e) => handleChange(e, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                ref={(element) => (inputsRef.current[index] = element)}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default MfaPhase2;